import { Layout } from 'antd';
import { useEffect, useState } from 'react';
import { getCustomerPendingPrices, getCustomers } from '../../redux/actions/customers';
import PrivateHeader from './Headers/Private';
import Menu from './Headers/Private/menu';
const { Sider, Content } = Layout;

const AppLayout = ({ children }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [notifications, setNotifications] = useState(0);

    const fetchPendingPrices = async () => {
        const res = await getCustomerPendingPrices();
        if (res?.ack) {
            setNotifications(res?.suggested_prices_count || 0);
        }
    };

    useEffect(() => {
        getCustomers();
        fetchPendingPrices();

        const intervalId = setInterval(() => {
            fetchPendingPrices();
        }, 60 * 30000); // 30 minutes

        return () => clearInterval(intervalId);
    }, []);

    return (
        <Layout className="app-layout">
            <PrivateHeader notifications={notifications} />

            <Layout className="app-body">
                <Sider
                    className="app-sider"
                    width={200}
                    collapsible
                    collapsed={collapsed}
                    onCollapse={(value) => setCollapsed(value)}
                    theme="dark"
                >
                    <Menu />
                </Sider>
                <Layout className="app-content-wrapper">
                    <Content className="app-content">{children}</Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default AppLayout;
